<template>
  <div class="col">
    <p>このプライバシーポリシーの目的は、tobook.linkウェブサイトおよびモバイルアプリケーション（以下、「tobook.link」「アプリ」）および予約サービスを利用する際の個人データの処理目的、範囲、処理期間、および個人の権利に関する情報をユーザー（以下、「ユーザー」）に提供することです。</p>
    <p>当社は、個人のプライバシーと個人データの保護に配慮し、個人データを適用法（EU）2016/679号、一般データ保護規則（以下、「規則」）およびプライバシーおよびデータ処理に関する他の法令に基づいて処理しています。</p>
    <p>tobook.linkは、サービスまたは適用法令および規制の変更により、いつでもこのポリシーを見直し、変更する権利を留保します。重要な変更がある場合は通知しますので、定期的にこのポリシーを確認する責任を負っていただきます。</p>
    <h6 class="mt-5 mb-3">
      コントローラーおよびその連絡先情報
    </h6>
    <p>個人データのコントローラーはtobook.link s.r.o.（登録番号：19608217）、法的住所：Pavla Beneše 750/8, Praha 19900です。個人データに関連する質問やリクエストについては、いつでもお問い合わせください。</p>
    <h6 class="mt-5 mb-3">
      個人データのカテゴリー
    </h6>
    <p>識別データ — 名前、姓、写真（任意）。連絡先情報 — 電話番号、メールアドレス。GDPRで定義される特別な個人データのカテゴリーは収集していません。</p>
    <h6 class="mt-5 mb-3">
      個人データ処理の目的
    </h6>
    <ul>
      <h6 class="mt-4">
        <li>事業者及び企業向け：</li>
      </h6>
      <p>1. tobook.linkアプリケーションへの登録（プロファイル作成）。</p>
      <p>2. tobook.linkアプリケーションの利用統計の匿名化された準備。</p>
      <p>3. 商業メッセージの送信。</p>
      <p>4. オンライン予約のアグリゲーターにおける企業情報の掲載。tobook.linkサービスを利用することにより、お客様の企業情報がtobook.linkが所有するオンライン予約アグリゲーターに掲載されることに同意します。これにより、お客様が提供したデータを使用してサービスのオンライン予約を行い、私たちのサービスの質を向上させることができます。</p>
      <h6 class="mt-4">
        <li>予約をするクライアント向け：</li>
      </h6>
      <p>1. 予約。お客様の個人データおよび予約の詳細は、予約履歴の閲覧および分析、ならびにサービス提供者の法的要件とそれに伴う義務のためにサービス提供者のアカウントに保管されます。</p>
      <p>2. 商業メッセージの送信。</p>
    </ul>
    <h6 class="mt-5 mb-3">
      ログエントリ
    </h6>
    <p>tobook.link Appの使用中にエラーが発生した場合、当社は第三者のソリューションを使用して、電話からデータと情報（ログエントリ）を収集します。これらのログエントリには、デバイスのIPアドレス、デバイス名、オペレーティングシステムのバージョン、アプリケーションの構成、サービスの利用時刻などの情報が含まれる場合があります。</p>
    <p>当社は、この情報を処理および収集し、tobook.link Appの操作、効率、およびユーザーエクスペリエンスを向上させるために使用します。このデータは、当社のAppを改善し、より良いサービスを提供するという正当な利益に基づいて処理されます。</p>
    <h6 class="mt-5 mb-3">
      支払処理
    </h6>
    <p>Tobook.linkで第三者プロバイダーのサービスを支払う際、支払いは当社の決済ゲートウェイプロバイダーであるStripeを通じて処理されます。クレジットカード情報またはデビットカード情報を直接Stripeに提供します。Stripeは支払詳細を処理する安全なサーバーを運用し、クレジットカード/デビットカード情報を暗号化して支払いを認証します。Tobook.linkはクレジットカード情報を収集しません。</p>
    <p>Stripeに提供する情報は当社の管理外であり、Stripe自体の<b-link href="https://stripe.com/en-jp/privacy" target="_blank">プライバシーポリシー</b-link>に準拠しています。</p>
    <p>tobook.link における個人事業主及び企業向けの支払処理サービスは、Stripeが提供し、<b-link href="https://stripe.com/en-jp/legal/connect-account" target="_blank">Stripe Connectアカウント契約</b-link>（<b-link href="https://stripe.com/en-jp/legal/ssa" target="_blank">Stripe利用規約</b-link>を含み、総称して「Stripeサービス契約」といいます。）に従うものとします。本契約への同意又はtobook.linkにおいて個人事業主又は企業としての取引の継続により、お客様はStripeサービス契約（随時Stripeにより修正されることがあり、その場合には修正されたものを含みます。）に拘束されることに同意するものとします。 Stripeを通じた支払処理サービスをtobook.linkができるようにするための条件として、お客様は、tobook.linkに対してお客様及びお客様の事業に関する正確かつ完全な情報を提供することに同意し、tobook.linkが当該情報及びStripeが提供する支払処理サービスのお客様による使用に関連する取引情報を共有することを認めるものとします。</p>
    <h6 class="mt-5 mb-3">
      個人データのセキュリティ
    </h6>
    <p>個人データを処理する際には、高度な技術的なソリューションを使用し、安全なサービスプロバイダーと連携し、プライバシーのリスクを評価し、当社の利用可能な組織と財務リソースを使用します。当社は、当社に委託されたデータに対して責任を負い、サービス提供に必要なデータ以外のデータを収集または処理しません。</p>
    <p>当社の従業員およびビジネスパートナーは、上記の目的にのみデータを使用し、厳格な契約上の機密保持義務に従うものとします。</p>
    <p>個人データは、データ処理がEUおよびEEAの領域で行われる安全なクラウドコンピューティングおよびサーバーソリューションに保存されます。このようなサービスの提供業者が変更される場合、当社は常に規制の要件を遵守する信頼性のあるパートナーとのみ協力することを保証します。ただし、電子的な保存方法は完全に安全で信頼性があり、欠陥がないとは言えないことに留意してください。</p>
    <h6 class="mt-5 mb-3">
      個人データ処理の法的根拠
    </h6>
    <p>tobook.link Appのユーザーの個人データは、以下の個人データ処理の法的根拠に基づいてのみ処理されます:</p>
    <ul>
      <li>特定の目的のために個人データの処理に対するあなたの同意。</li>
      <li>契約の締結または履行、または契約締結前のお客様の要求に対する措置を講じるためのデータ処理の必要性。</li>
      <li>法的義務の履行のためのデータ処理。</li>
      <li>あなたまたは他の人々の生命、身体、または財産の保護のためのデータ処理。</li>
      <li>公的利益のために行われるタスクの実施のためのデータ処理。</li>
      <li>あなたの利益または基本的な権利と自由に優越しない限り、当社または第三者の正当な利益のためのデータ処理。</li>
    </ul>
    <h6 class="mt-5 mb-3">
      個人データの保持期間
    </h6>
    <p>個人データは以下の期間だけ保存されます:</p>
    <ul>
      <li>
        データが収集された目的のために必要な期間。
      </li>
      <li>
        データ主体と当社が法律および規制に基づいて正当な利益を行使できる場合（異議を申し立てるか、裁判所に訴えるか）。
      </li>
      <li>
        個人データの保存義務がある場合。
      </li>
      <li>
        関連する個人データの処理に対するデータ主体の同意が有効である場合、データ処理に別の法的根拠が存在しない限り。
      </li>
    </ul>
    <p>これらの期間を経過した後、個人データは永久に削除されるか匿名化され、あなたと関連付けることはできなくなります。</p>
    <h6 class="mt-5 mb-3">
      データの第三者への転送
    </h6>
    <p>tobook.link Appの運用を確保するために、以下の個人データを処理する可能性のある第三者サービス（「プロセッサー」）を使用しています:</p>
    <!-- link -->
    <table-partners />
    <cite>*これらの第三者のプライバシーポリシーとデータ処理方法については、お読みください。</cite>
    <p class="mt-1">
      当社は、次の場合を除いて、個人データを他の第三者に開示しません：
    </p>
    <ul>
      <li>明示的かつ明確な同意に基づいて開示する場合。</li>
      <li>法令で定められた手続きおよび範囲に従って規制法令で定められた者に提供する場合。</li>
      <li>詐欺の検出、予約条件またはポリシーの違反、その他の違法行為の調査、または当社の権利、財産、安全、または他者の権利、財産、安全を保護するためなど、正当な利益の保護のために規制法令で定められた場合。</li>
    </ul>
    <h6 class="mt-5 mb-3">
      他のサイトへのリンク
    </h6>
    <p>tobook.linkアプリは、tobook.linkが管理するユーザーの個人データに関するデータ処理ルールを持たない他のウェブサイトやアプリへのリンクを含む場合があります。したがって、これらのウェブサイトの機密保持ポリシーを必ずお読みいただくことを強くお勧めします。第三者のウェブサイトやサービスの内容やプライバシーポリシーについて、当社は管理または責任を負いません。</p>
    <h6 class="mt-5 mb-3">
      児童のプライバシー
    </h6>
    <p>tobook.linkアプリで利用可能なサービスは、13歳未満の人には適用されません。13歳未満の子供から個人情報を受け取った場合、当社はtobook.linkサービスを一時停止し、データをシステムから削除します。もし、あなたが子供の親または保護者であり、あなたの子供が個人情報を提供したことを知っている場合は、必要な措置を取るために当社に連絡してください。</p>
    <h6 class="mt-5 mb-3">
      商業的な通信
    </h6>
    <p>tobook.linkとユーザーとの間の法的関係および規則に従い、規則に基づいて正当な利益に基づいて商業的な通信を送信することがあります。このような通信は、予約とユーザーが選択したサービスに関連するサービスやオファーに関して送信される場合があります。</p>
    <p>他のサービスの商業的な通信は、ユーザーがそのような通信を受け取ることに同意した場合にのみユーザーに送信されます。メール内の購読解除リンクを使用するか、直接当社に連絡することで、いつでもこれらの通信を受け取らないようにする権利を有しています。</p>
    <h6
      id="cookies"
      class="mt-5 mb-3"
    >
      「クッキー」
    </h6>
    <p>クッキーとは、ウェブサイトの閲覧中にブラウザによってコンピュータやモバイルデバイスに保存される小さなデータのことです。これにより、サーバーはブラウザから情報を収集し、ウェブサイトに戻る際やページ間を移動する際にデータの再入力が必要なくなります。クッキーの動作についての詳細は、ウェブサイト
      <b-link
        target="_blank"
        href="http://www.cookiecentral.com"
      >www.cookiecentral.com</b-link>を参照してください。</p>
    <p>当社は、以下の目的でクッキーを使用します：tobook.linkアプリは、サービスの品質を向上させるためにクッキーを使用し、Appの利用の匿名統計データやマーケティング目的で得られたデータの分析を行います。セキュリティのためのクッキー、セッションクッキー、分析クッキー（ファーストパーティおよびサードパーティ（パートナー）クッキー）を使用します。</p>
    <ul>
      <li>Appのセキュリティを確保し、管理する。</li>
      <li>Appの使用言語を記憶する。</li>
      <li>クッキーの使用に対する同意の有無を記憶する。</li>
      <li>マーケティングキャンペーンの効果を測定するのに役立つ。</li>
      <li>Appの使用状況に関する情報を収集し、ユーザーのニーズにどれだけ満たされているかを測定し、必要な改善を行う。</li>
      <li>一部のクッキーは、当社のニーズを満たすために特定の機能を実行するサービスプロバイダーによってコンピュータに配置される場合があります（例：Google）。</li>
    </ul>
    <p>tobook.linkアプリでは、同意を必要としないクッキーも使用しています。これらは次のようなものです:</p>
    <ul>
      <li>セッション中のみ有効な情報のクッキー。</li>
      <li>セッション中のみ有効な認証クッキー。</li>
    </ul>
    <h6 class="mt-5 mb-3">
      個人データとその転送
    </h6>
    <p>クッキーに関連する情報は、個人を特定するためには使用されません。ただし、この情報を本ポリシーで説明された目的に沿って保持している他の情報と関連付ける場合があります。</p>
    <p>当社は、当社にサービスを提供する第三者とデータを共有する場合があります（例：tobook.linkアプリの分析、カスタマーサービスなど）。これらの個人は、これらのサービスを提供するために必要な範囲でのみデータを使用する権限を持っています。</p>
    <p>当社は、このプライバシーポリシーで説明されている範囲内でのみデータを第三者に提供します。個人データを第三者に販売することはありません。</p>
    <h6 class="mt-5 mb-3">
      あなたの権利
    </h6>
    <p>いつでも個人データに関する情報を要求し、保管されている情報の正確性を確認したり、この情報を変更または更新することができます。また、法的根拠がない限り、データがそれ以上の処理に必要でない場合は、個人データの完全な削除を要求することもできます（ただし、法的義務により保持する必要がある場合を除く）。</p>
    <p>当社は、リクエストを受け取ってから1ヵ月以内に、商業的に合理的な努力を行い、個人データに関する適切なアクセスを提供するよう努めます（例外的な状況がある場合はお知らせします）。</p>
    <p>プライバシーとセキュリティを保護するために、情報提供を行う前に、あなたの身元を確認するための適切な手順を講じます。</p>
    <h6 class="mt-5 mb-3">
      苦情
    </h6>
    <p>苦情やリクエストは、以下に送信することができます：<b-link
      :to="{name: 'partners'}"
    >tobook.link</b-link></p>
    <p>当社があなたの法的権利を侵害していると考える場合、データ州監督機関に苦情を提出することができます：Česká obchodní inspekce, Štěpánská 44, 110 00 Praha 1</p>
  </div>
</template>

<script>
import {
  BLink,
} from 'bootstrap-vue'
import TablePartners from '@/components/policy/TablePartners.vue'

export default {
  name: 'JaPrivacyPolicy',
  components: {
    TablePartners,
    BLink,
  },
}
</script>

<style scoped>

</style>
